<template>
  <div>
    <div>
      <div class="form">
        <div class="kt-form__group form-group mt-2">
          <label>Current Bit Rate : {{ current_bitrate_formatted }}</label>
          <select
            v-model="selected" v-validate="'required'"
            name="bitrate" class="form-control"
            :disabled="select_disabled">
            <option
              v-for="(option, index) in available_bit_rates" :key="index"
              :value="option.value">
              {{ option.text }}
            </option>
          </select>
          <span v-show="errors.has('bitrate')" class="text-ss-danger">
            {{ errors.first('bitrate') }}
          </span>
        </div>
      </div>

      <button
        id="reduce_bitrate_button" type="button"
        class="btn btn-ss-standout"
        data-style="expand-right"
        :disabled="select_disabled" @click.prevent="reduceBitRate">
        Reduce Bit Rate
      </button>
    </div>

    <vjs-modal name="bitrate_update_processing" title="Bitrate Reduction Processing">
      <template #body-content>
        <p>
          Your bitrate reduction is being processed. This is estimated to take {{ bitrate_estimate_minutes }} minutes.
          It is safe to close this modal, once complete, a new storage asset will be added.
        </p>
        <div class="text-center">
          <div class="spinner-border" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
        <div class="text-center mt-4 mb-4">
          <a href="/storage" class="btn btn-ss-standout">View Storage</a>
        </div>
      </template>
    </vjs-modal>
    <vjs-modal name="bitrate_update_failed" title="Bitrate Reduction Failed">
      <template #body-content>
        <p>
          We were unable to reduce the bitrate for this file. Please contact SharpStream Support.
        </p>
      </template>
    </vjs-modal>
  </div>
</template>

<script>
import Ladda from 'ladda';
import 'ladda/dist/ladda-themeless.min.css';
import VjsModal from "VueModals/VjsModal";

export default {
  name: "Converter",
  components: {
    VjsModal,
  },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  data: () => ({
    bitrate: null,
    minimum_bit_rate: 96,
    selected: 96,
    bit_rates: [96, 128, 320],
    bit_rate_types: ['mp3'],
    submit_ladda: null,
    new_file_checked: 1,
    bitrate_estimate_minutes: 5,
  }),
  computed: {
    current_bitrate_formatted() {
      return this.formatBitRate(this.current_bitrate);
    },
    ffmpeg_data() {
      return this.item.ffmpeg_details;
    },
    current_bitrate() {
      if (this.ffmpeg_data && this.ffmpeg_data.bitrate) {
        return this.ffmpeg_data.bitrate;
      }
      return 'Could not calculate';
    },
    filename() {
      return this.item.name;
    },
    available_bit_rates() {
      const available_bit_rates = [];
      for (const bit_rate in this.bit_rates) {
        if (this.bit_rates[bit_rate] < this.convertToKBits(this.current_bitrate)) {
          const data = {
            text: this.bit_rates[bit_rate] + ' Kbps',
            value: this.bit_rates[bit_rate],
          };
          available_bit_rates.push(data);
        }
      }

      return available_bit_rates;
    },
    select_disabled() {
      return !this.available_bit_rates.length;
    },
  },
  watch: {
    item() {
      this.submit_ladda = Ladda.create(document.querySelector('#reduce_bitrate_button'));
    },
  },
  mounted() {
    this.estimateBitrateTime();
    EventBus.$on(`bitrate_updated_${this.item.uuid}`, () => {
      this.hideModal("bitrate_update_processing");
    });

    EventBus.$on(`bitrate_failed_${this.item.uuid}`, () => {
      this.hideModal("bitrate_update_processing");
      this.fireModal("bitrate_update_failed");
    });
    if (!this.bannedFileExtension) {
      this.submit_ladda = Ladda.create(document.querySelector('#reduce_bitrate_button'));
    }
  },
  methods: {
    estimateBitrateTime() {
      const duration_in_seconds = this.item.ffmpeg_details.duration;
      const average_speed_multiplier = 25;
      const estimated_conversion_seconds = duration_in_seconds / average_speed_multiplier;
      // convert to minutes
      this.bitrate_estimate_minutes = Math.floor(estimated_conversion_seconds / 60);
    },
    reduceBitRate() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.submit_ladda.start();
          this.fireModal("bitrate_update_processing");
          axios.patch(`/api/v1/storage/bitrate/${window.item.uuid}/reduce`, {
            bitrate: this.selected,
            new_file: this.new_file_checked,
          }).then(() => {
            this.submit_ladda.stop();
          }).catch((error) => {
            window.handleAxiosError(error);
            this.submit_ladda.stop();
          });
        }
      });
    },
    formatBitRate(bit_rate) {
      return this.convertToKBits(bit_rate) + ' Kbps';
    },
    convertToKBits(bit_rate) {
      return Math.floor(bit_rate / 1000);
    },
    getFileExtension(filename) {
      const re = /(?:\.([^.]+))?$/;
      return re.exec(filename)[1];
    },
  },
};
</script>

<style scoped>
    .new-file-checkbox {
        margin-top:8px;
    }
</style>
